<!--
    @修改人：黎柏祺
    @修改时间：2018-11-28
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @负责人: 黎柏祺
    @创建时间: 2018-05-15
    @版本:v1.0.16
    @描述: 编辑告警组件
-->
<template>
  <div class="addStratagy__content">
    <g-back :history="history"></g-back>
    <div class="addStratagy__form">
      <el-form ref="form"
        :model="form"
        :inline="true"
        label-width="100px"
        :rules="rules">
        <el-form-item :label="$t('alarmStrategy.alarmName')"
          prop="alarmName">
          <el-input v-model="form.alarmName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmType')"
          prop="alarmType">
          <g-select :list="select_alarmType"
            v-model="form.alarmType"></g-select>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmCode')"
          prop="alarmCode">
          <el-input v-model="form.alarmCode"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.triggerStyle')"
          prop="trgType">
          <g-select :list="select_triggerStyle"
            v-model="form.trgType"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.site')"
          prop="siteCode">
          <g-select :list="siteList"
            v-model="form.siteCode"></g-select>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.appGroup')"
          prop="group">
          <g-select :list="groupList"
            v-model="form.group"
            v-if="!searchDataFlag"></g-select>
          <el-input v-model="form.group"
            disabled
            v-else></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmTag')"
          v-show="form.sourceType==='2'">
          <el-input v-model="form.tag"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.appName')"
          prop="appName">
          <g-select :list="appList"
            v-model="form.appName"
            v-if="!searchDataFlag"></g-select>
          <el-input v-model="form.appName"
            disabled
            v-else></el-input>
        </el-form-item>
        <el-form-item :label="form.sourceType === '1' ? $t('alarmStrategy.kpiKey') : $t('alarmStrategy.alarmKey')"
          prop="kpiKey">
          <el-input v-model="form.kpiKey"
            v-if="!searchDataFlag&&form.sourceType!=='1'"></el-input>
          <g-select :list="kpiKeyList"
            v-model="form.kpiKey"
            v-else-if="!searchDataFlag&&form.sourceType==='1'"
            @change="setKpiDesc"></g-select>
          <g-select :list="kpiKeyList"
            v-model="form.kpiKey"
            v-else-if="searchDataFlag"
            :tdisabled="disabled"></g-select>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmLevel')"
          v-show="form.sourceType !== '1'">
          <g-select :list="select_alarmLevel"
            v-model="form.alarmLevel"></g-select>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.timingOn')"
          v-show="!form.enable">
          <el-input-number style="width: 102px"
            :min="0"
            v-model="form.timer"></el-input-number>
          <g-select style="width: 74px"
            v-model="form.unit"
            :list="select_timeUnit"></g-select>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmSource')"
          v-if="form.sourceType==='3'">
          <el-input v-model="form.alarmSource"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.enable')"
          class="addStratagy__w700">
          <el-radio v-model="form.enable"
            :label="true">{{$t('alarmStrategy.yes')}}</el-radio>
          <el-radio v-model="form.enable"
            :label="false">{{$t('alarmStrategy.no')}}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.mailGroups')">
          <div class="addStratagy__checkbox">
            <el-checkbox-group v-model="form.mailGroups">
              <el-checkbox v-for="(item,index) in userGroups"
                :label="item"
                :key="index"
                class="addStratagy__checkItem"></el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.messageGroups')">
          <div class="addStratagy__checkbox">
            <el-checkbox-group v-model="form.messageGroups">
              <el-checkbox v-for="(item,index) in userGroups"
                :label="item"
                :key="index"
                class="addStratagy__checkItem"></el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmRule')"
          class="addStratagy__w700"
          v-if="form.sourceType==='1'">
          <dynamic-table ref="dynamicTable"
            :input-data="tableDatas"
            :model="tableModels"
            :add-fun="getDdatas"
            :custom-fun="deleteDdatas">
            <el-button :slot="'operation'+index"
              v-for="(item,index) in tData"
              :key="index"
              :class="[item.processSteps !==null&&item.processSteps.length!==0?'el-button--primary':'none']"
              @click="addTreatProcess(item,index)">
              &nbsp;&nbsp;{ }&nbsp;&nbsp;
            </el-button>
          </dynamic-table>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmRule')"
          v-if="form.sourceType==='2'">
          <dynamic-table ref="dynamicTable"
            :input-data="tableData"
            :model="tableModel"
            :custom-fun="deleteDdata">
          </dynamic-table>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.alarmMapRule')"
          class="addStratagy__w700"
          v-if="form.sourceType==='2'">
          <table class="t-tableMin t-table">
            <thead>
              <tr class="kpi-t-title">
                <th class="t-border t-map">{{$t('alarmStrategy.tagField')}}</th>
                <th class="t-border t-map">{{$t('alarmStrategy.tagFieldType')}}</th>
                <th class="t-border t-map">{{$t('alarmStrategy.sourceField')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="t-border t-nopd"
                  v-text="$t('alarmStrategy.alarmObject')"></td>
                <td class="t-border t-nopd"
                  v-text="'STRING'"></td>
                <td class="t-border t-nopd">
                  <el-input v-model="alarmMapRule[0].sourceField"></el-input>
                </td>
              </tr>
              <tr>
                <td class="t-border t-nopd"
                  v-text="$t('alarmStrategy.alarmAddress')"></td>
                <td class="t-border t-nopd"
                  v-text="'STRING'"></td>
                <td class="t-border t-nopd">
                  <el-input v-model="alarmMapRule[1].sourceField"></el-input>
                </td>
              </tr>
              <tr>
                <td class="t-border t-nopd"
                  v-text="$t('alarmStrategy.alarmTime')"></td>
                <td class="t-border t-nopd"
                  v-text="'LONG'"></td>
                <td class="t-border t-nopd">
                  <el-input v-model="alarmMapRule[2].sourceField"></el-input>
                </td>
              </tr>
              <tr>
                <td class="t-border t-nopd"
                  v-text="$t('alarmStrategy.alarmContent')"></td>
                <td class="t-border t-nopd"
                  v-text="'STRING'"></td>
                <td class="t-border t-nopd">
                  <el-input v-model="alarmMapRule[3].sourceField"></el-input>
                </td>
              </tr>
              <tr>
                <td class="t-border t-nopd"
                  v-text="$t('alarmStrategy.locationInfo')"></td>
                <td class="t-border t-nopd"
                  v-text="'STRING'"></td>
                <td class="t-border t-nopd">
                  <el-input v-model="alarmMapRule[4].sourceField"></el-input>
                </td>
              </tr>
            </tbody>
          </table>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.processPlan')"
          prop="processPlan"
          class="addStratagy__w700">
          <el-input v-model="form.processPlan"
            type="textarea"
            class="addStratagy__w500"
            :autosize="{ minRows: 5}"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmStrategy.remarks')"
          class="addStratagy__w700"
          v-if="form.sourceType === '3'">
          <el-input v-model="form.remarks"
            type="textarea"
            class="addStratagy__w500"
            :autosize="{ minRows: 5}"></el-input>
        </el-form-item>
        <el-form-item class="addStratagy__center">
          <el-button type="primary"
            v-g-rac="gRac('alarmStrategy_add')"
            @click="e_save">{{ $t('common.save') }}</el-button>
          <el-button @click="e_cancel">{{ $t('common.cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog :closeOnClickModal="false"
      :title="$t('alarmStrategy.processSteps')"
      :visible.sync="dialogVisible">
      <el-form ref="processForm">
        <div v-for="(item,index) in processSteps"
          :key="index"
          class="mb-base">
          {{$t('alarmStrategy.step')}}{{index + 1}}
          <el-input class="addStratagy__w200 mb-base"
            v-model="item.stepName"></el-input>
          <el-button type="danger"
            @click="deleteStep(index)">{{$t('alarmStrategy.delete')}}</el-button>
          <el-input v-model="item.action"
            type="textarea"
            :autosize="{ minRows: 5}"></el-input>
        </div>
        <div>
          <el-button type="primary"
            @click="addStep">{{$t('alarmStrategy.add')}}</el-button>
        </div>
      </el-form>
      <div slot="footer"
        class="dialog-footer">
        <el-button @click="closeDialog">{{$t('common.cancel')}}</el-button>
        <el-button type="primary"
          @click="e_saveTreatProcess">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import SiteListBiz from "@/logic/cmdb/cmdbBiz";
import alarmStrategyBiz from "@/logic/systemSetting/alarmStrategyBiz.js";
import validateConfig from "@/utils/validate";
import dic from "@/components/mixins/dic";
import rac from "@/plugins/rac-mixin.js";
import alarmSubscribeBiz from "@/logic/systemSetting/alarmSubscribeBiz.js";
import dynamicTable from "@/components/dynamicTable";
import { extend } from "@/utils/tool";

export default {
  mixins: [dic, rac],
  data() {
    const that = this;
    return {
      form: {
        alarmCode: "",
        alarmName: "",
        alarmLevel: null,
        alarmMapRule: null,
        alarmRules: null,
        alarmType: null,
        appName: "",
        enable: true,
        siteCode: "",
        group: "",
        kpiKey: "",
        mailGroups: [],
        messageGroups: [],
        processPlan: null,
        sourceType: "",
        tag: null,
        trgType: null,
        timer: 0,
        unit: "H",
        alarmSource: "",
        remarks: ""
      },
      groupList: {},
      alarmMapRule: [
        {
          tagField: "alarmObject",
          tagFieldType: "STRING",
          sourceField: ""
        },
        {
          tagField: "alarmAddress",
          tagFieldType: "STRING",
          sourceField: ""
        },
        {
          tagField: "alarmTime",
          tagFieldType: "LONG",
          sourceField: ""
        },
        {
          tagField: "alarmContent",
          tagFieldType: "STRING",
          sourceField: ""
        },
        {
          tagField: "locationInfo",
          tagFieldType: "STRING",
          sourceField: ""
        }
      ],
      siteList: {},
      isIndeterminate: true,
      checkAll: false,
      dialogVisible: false,
      rules: {},
      alarmRules: [],
      processSteps: [],
      select_alarmType: {},
      select_alarmLevel: {},
      appList: {},
      select_triggerStyle: {},
      userGroups: {},
      kpiKeyList: {},
      allKpiData: [],
      kpiType: "",
      kpiDesc: "",
      alarmRuleList: {},
      // alarmCountType: '',
      mailGroupsSelect: {},
      msgGroupsSelect: {},
      alarmCountTypeList: {},
      timeList: {},
      enableList: {
        yes: that.$t("alarmStrategy.yes"),
        no: that.$t("alarmStrategy.no")
      },
      processIndex: null,
      history: [],
      searchDataFlag: false,
      disabled: true,
      tableData: [],
      tableModel: {},
      tableDatas: [],
      tableModels: {},
      tData: [],
      select_timeUnit: {}
    };
  },
  computed: {},
  methods: {
    e_init() {
      let timeArr = {
        none: "--"
      };
      for (let i = 0; i < 24; i++) {
        timeArr[i] = i;
      }
      this.timeList = timeArr;
      this.waitaAlarmType();
      this.waitAlarmLevel();
      this.waitTriggertype();
      this.waitAlarmCountType();
      this.getSiteList();
      this.waitAlarmRule();
      this.waitTimeUnit();
      this.findUserGroups();
      this.setRule();
      this.init();
    },
    async waitGroupList(siteCode, siteChange) {
      await this.dGetGroup(siteCode, siteChange);
      this.groupList = this.$store.state.dicModule.group;
    },
    async waitaAlarmType() {
      await this.dGetDictionaryByCode("alarmType");
      this.select_alarmType = { ...this.dDictionary.alarmType };
      this.form.alarmType = Object.keys(this.select_alarmType)[0];
    },
    async waitAlarmLevel() {
      await this.dGetDictionaryByCode("alarmLevel");
      this.select_alarmLevel = { ...this.dDictionary.alarmLevel };
      this.form.alarmLevel = Object.keys(this.select_alarmLevel)[0];
    },
    async waitTriggertype() {
      await this.dGetDictionaryByCode("triggertype");
      this.select_triggerStyle = { ...this.dDictionary.triggertype };
      this.form.trgType = Object.keys(this.select_triggerStyle)[0];
    },
    async waitTimeUnit() {
      await this.dGetDictionaryByCode("timeunittype");
      this.select_timeUnit = { ...this.dDictionary.timeunittype };
    },
    async waitAlarmRule() {
      await this.dGetDictionaryByCode("alarmRule");
      this.alarmRuleList = { ...this.dDictionary.alarmRule };
      setTimeout(() => {
        this.setDynamicData();
      }, 100);
    },
    async waitAlarmCountType() {
      await this.dGetDictionaryByCode("alarmCountType");
      this.alarmCountTypeList = { ...this.dDictionary.alarmCountType };
    },
    async waitAppList(siteCode, group) {
      await this.dGetAppByGroup(siteCode, group);
      this.appList = { ...this.dDictionaryApp[group] };
      if (this.$route.query.appName) return;
      this.form.appName = Object.keys(this.appList)[0];
    },
    getSiteList() {
      if (Object.keys(this.siteList).length > 0) {
        this.form.siteCode = Object.keys(this.siteList)[0];
      } else {
        SiteListBiz.siteList({ perPageCount: 500 }).then(data => {
          let list = {};
          data.dataList.map(item => {
            list[item.siteCode] = item.name;
          });
          this.siteList = list;
          this.form.siteCode = Object.keys(list)[0];
        });
      }
    },
    setRule() {
      const array = [
        "alarmName",
        "alarmType",
        "trgType",
        "group",
        "kpiKey",
        "alarmCode",
        "appName",
        "processPlan"
      ];
      array.map(item => {
        this.rules[item] = [{ ...validateConfig.common.notEmpty }];
      });
    },
    setDynamicData() {
      this.tableData = [
        {
          label: this.$t("alarmStrategy.field"),
          key: "field"
        },
        {
          label: this.$t("alarmStrategy.rule"),
          key: "rule",
          type: "select",
          select: this.alarmRuleList
        },
        {
          label: this.$t("alarmStrategy.value"),
          key: "value"
        },
        {
          label: this.$t("alarmStrategy.alarmMoment"),
          type: "rangeSelect",
          fkey: "startTime",
          skey: "endTime",
          select: this.timeList
        }
      ];
      this.tableModel = {
        rule: Object.keys(this.alarmRuleList)[0],
        value: "",
        field: "",
        startTime: "none",
        endTime: "none"
      };
      this.tableDatas = [
        {
          label: this.$t("alarmStrategy.kpiKey"),
          key: "kpiKey",
          disabled: true
        },
        {
          label: this.$t("alarmStrategy.rule"),
          key: "rule",
          type: "select",
          select: this.alarmRuleList
        },
        {
          label: this.$t("alarmStrategy.value"),
          key: "value"
        },
        {
          label: this.$t("alarmStrategy.duration"),
          key: "triggerTime",
          disabled: this.form.trgType === "1"
        },
        {
          label: this.$t("alarmStrategy.alarmMoment"),
          type: "rangeSelect",
          fkey: "startTime",
          skey: "endTime",
          select: this.timeList
        },
        {
          label: this.$t("alarmStrategy.alarmLevel"),
          type: "select",
          key: "alarmLevel",
          select: this.select_alarmLevel
        },
        {
          label: this.$t("alarmStrategy.alarmCountType"),
          type: "select",
          key: "countType",
          select: this.alarmCountTypeList
        }
      ];
      this.tableModels = {
        kpiKey: this.kpiDesc,
        rule: Object.keys(this.alarmRuleList)[0],
        value: "",
        triggerTime: this.form.trgType !== "1" ? "" : 0,
        alarmLevel: Object.keys(this.select_alarmLevel)[0],
        countType: Object.keys(this.alarmCountTypeList)[0],
        startTime: "none",
        endTime: "none",
        processSteps: []
      };
    },
    getDdatas(val) {
      this.tData = extend(true, [], val);
    },
    deleteDdatas(item, i) {
      const d = this.$refs.dynamicTable.getData();
      d.splice(i, 1);
      this.tData = d;
      this.$refs.dynamicTable.setData(d);
    },
    deleteDdata(item, i) {
      const d = this.$refs.dynamicTable.getData();
      d.splice(i, 1);
      this.$refs.dynamicTable.setData(d);
    },
    init() {
      setTimeout(() => {
        this.form.sourceType = this.$route.query.sourceType;
        this.history = [];
        let nameList = {
          1: this.$t("alarmStrategy.addKpiAlarm"),
          2: this.$t("alarmStrategy.addThirdAlarm"),
          3: this.$t("alarmStrategy.addalarmRegist")
        };
        this.history.push({ name: nameList[this.$route.query.sourceType] });
        if (this.$route.query.appName !== undefined) {
          this.searchDataFlag = true;
          this.form.appName = this.$route.query.appName;
          this.form.group = this.$route.query.appGroup;
          this.form.kpiKey = this.$route.query.kpiKey;
          if (this.form.sourceType === "1") {
            this.findKpiKeys();
          }
          this.waitAppList(this.form.siteCode, this.form.group);
        } else {
          this.searchDataFlag = false;
        }
      }, 100);
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    addStep() {
      this.processSteps.push({
        action: "",
        stepName: ""
      });
    },
    deleteStep(i) {
      this.processSteps.splice(i, 1);
    },
    findUserGroups() {
      alarmSubscribeBiz.getGroup({ perPageCount: 500 }).then(data => {
        const userGroupArr = [];
        data.dataList.forEach(function(item) {
          userGroupArr[item.groupName] = item.groupName;
        });
        this.userGroups = { ...userGroupArr };
      });
    },
    findKpiKeys() {
      const that = this;
      const info = {
        group: this.form.group,
        appName: this.form.appName,
        currentPage: 1,
        perPageCount: 50
      };
      alarmSubscribeBiz.getKpiKey(info).then(function(data) {
        let kpiKeyList = {};
        that.allKpiData = data.dataList;
        that.allKpiData.forEach(function(item) {
          if (item.desc === "") return;
          kpiKeyList[item.kpiKey] = item.desc;
        });
        that.kpiKeyList = { ...kpiKeyList };
        if (!that.searchDataFlag) {
          that.form.kpiKey =
            Object.keys(that.kpiKeyList).length !== 0
              ? Object.keys(that.kpiKeyList)[0]
              : "";
        }
        that.kpiDesc =
          that.form.kpiKey === "" ? "" : that.kpiKeyList[that.form.kpiKey];
        let d = [...that.$refs.dynamicTable.getData()];
        d.forEach(item => {
          item.kpiKey = that.kpiDesc;
        });
        that.$refs.dynamicTable.setData(d);
        that.tableModels.kpiKey = that.kpiDesc;
        if (that.allKpiData.length !== 0) {
          for (let i = 0; i < that.allKpiData.length; i++) {
            if (that.allKpiData[i].kpiKey === that.form.kpiKey) {
              that.kpiType = that.allKpiData[i].kpiType;
              break;
            } else {
              that.kpiType = that.allKpiData[0].kpiType;
            }
          }
        }
      });
    },
    setKpiDesc(val) {
      this.kpiDesc = val.value;
      let d = [...this.$refs.dynamicTable.getData()];
      d.forEach(item => {
        item.kpiKey = this.kpiDesc;
      });
      this.$refs.dynamicTable.setData(d);
    },
    deleteTable(i) {
      this.alarmRules.splice(i, 1);
    },
    addTreatProcess(d, i) {
      this.dialogVisible = true;
      this.processSteps =
        d.processSteps === null ? [] : extend(true, [], d.processSteps);
      this.processIndex = i;
    },
    e_saveTreatProcess() {
      for (let i in this.processSteps) {
        if (this.processSteps[i].stepName === "") {
          this.$message({
            message: this.$t("alarmStrategy.rules.stepName"),
            type: "warning"
          });
          return;
        }
      }
      const d = this.$refs.dynamicTable.getData();
      d[this.processIndex].processSteps = this.processSteps;
      this.tData = d;
      this.$refs.dynamicTable.setData(d);
      this.dialogVisible = false;
    },
    e_cancel() {
      this.$router.push({ name: "alarmStrategy" });
    },
    e_save() {
      if (this.form.sourceType === "3") return this._save();
      this.alarmRules = [...this.$refs.dynamicTable.getData()];
      this.$refs.form.validate(valid => {
        if (valid) {
          for (let i in this.alarmRules) {
            if (this.alarmRules[i].value === "") {
              this.$message({
                message: this.$t("alarmStrategy.rules.value"),
                type: "warning"
              });
              return;
            }
            if (this.alarmRules[i].triggerTime === "") {
              this.$message({
                message: this.$t("alarmStrategy.rules.triggerTime"),
                type: "warning"
              });
              return;
            }
            if (this.alarmRules[i].startTime === "none") {
              this.alarmRules[i].startTime = null;
            }
            if (this.alarmRules[i].endTime === "none") {
              this.alarmRules[i].endTime = null;
            }
            if (this.form.enable) {
              this.form.timer = null;
              this.form.unit = null;
            }
            if (this.form.sourceType === "2") {
              delete this.alarmRules[i].processSteps;
              delete this.alarmRules[i].triggerTime;
              delete this.alarmRules[i].countType;
              delete this.alarmRules[i].alarmLevel;
            }
            if (this.form.sourceType === "1") {
              delete this.alarmRules[i].field;
            }
          }
          this.form.alarmRules = [...this.alarmRules];
          if (this.form.sourceType === "2") {
            this.form.alarmMapRule = this.alarmMapRule;
          }
          if (this.form.sourceType === "1") {
            delete this.form.alarmLevel;
          }
          this.form.alarmRules.forEach((item, index) => {
            delete item.kpiKey;
          });
          alarmStrategyBiz.addStrategy(this.form).then(data => {
            this.$message({
              message: this.$t("common.success"),
              type: "success"
            });
            setTimeout(() => {
              this.$router.push({ name: "alarmStrategy" });
            }, 500);
          });
        }
      });
    },
    _save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          alarmStrategyBiz.addStrategy(this.form).then(data => {
            this.$message({
              message: this.$t("common.success"),
              type: "success"
            });
            setTimeout(() => {
              this.$router.push({ name: "alarmStrategy" });
            }, 500);
          });
        }
      });
    },
    resetForm() {
      this.$refs.form.clearValidate();
      this.form = {
        alarmCode: "",
        alarmName: "",
        alarmLevel: Object.keys(this.select_alarmLevel)[0],
        alarmMapRule: null,
        alarmRules: null,
        alarmType: Object.keys(this.select_alarmType)[0],
        siteCode:
          Object.keys(this.siteList).length > 0
            ? Object.keys(this.siteList)[0]
            : "",
        enable: true,
        group: "",
        appName: "",
        kpiKey: "",
        mailGroups: [],
        messageGroups: [],
        processPlan: null,
        tag: null,
        sourceType: "",
        trgType: Object.keys(this.select_triggerStyle)[0],
        timer: 0,
        unit: "H",
        alarmSource: "",
        remarks: ""
      };
      this.alarmMapRule = [
        {
          tagField: "alarmObject",
          tagFieldType: "STRING",
          sourceField: ""
        },
        {
          tagField: "alarmAddress",
          tagFieldType: "STRING",
          sourceField: ""
        },
        {
          tagField: "alarmTime",
          tagFieldType: "LONG",
          sourceField: ""
        },
        {
          tagField: "alarmContent",
          tagFieldType: "STRING",
          sourceField: ""
        },
        {
          tagField: "locationInfo",
          tagFieldType: "STRING",
          sourceField: ""
        }
      ];
      this.alarmRules = [];
      this.kpiKeyList = {};
      this.allKpiData = [];
      this.checkAll = false;
      this.kpiType = "";
      this.kpiDesc = "";
      this.processIndex = null;
      this.tData = [];
      this.$refs.dynamicTable && this.$refs.dynamicTable.setData(this.tData);
    }
  },
  components: {
    dynamicTable
  },
  watch: {
    "form.trgType"(val) {
      this.tableDatas.forEach((item, index) => {
        if (
          this.form.trgType === "1" &&
          item.label === this.$t("alarmStrategy.duration")
        ) {
          item.disabled = true;
          this.tableModels.triggerTime = 0;
          let data = [...this.$refs.dynamicTable.getData()];
          data.forEach(item => {
            item.triggerTime = 0;
          });
          this.$refs.dynamicTable.setData(data);
        } else if (
          this.form.trgType !== "1" &&
          item.label === this.$t("alarmStrategy.duration")
        ) {
          item.disabled = false;
          this.tableModels.triggerTime = "";
          let data = [...this.$refs.dynamicTable.getData()];
          data.forEach(item => {
            item.triggerTime = "";
          });
          this.$refs.dynamicTable.setData(data);
        }
      });
    },
    "form.siteCode": function(val) {
      this.waitGroupList(val, true);
    },
    "form.enable": function(val) {
      this.form.timer = 2;
      this.form.unit = "H";
    },
    kpiType(val) {
      if (val === "KPICOUNT") {
        this.tableDatas.forEach(item => {
          if (item.label === this.$t("alarmStrategy.alarmCountType")) {
            item.disabled = false;
          }
        });
      } else {
        let data = [...this.$refs.dynamicTable.getData()];
        data.forEach(item => {
          item.countType = Object.keys(this.alarmCountTypeList)[0];
        });
        this.$refs.dynamicTable.setData(data);
        this.tableDatas.forEach(item => {
          if (item.label === this.$t("alarmStrategy.alarmCountType")) {
            item.disabled = true;
          }
        });
      }
    },
    $route(to, from) {
      if (to.name === "addStrategy") {
		this.findUserGroups();
        this.init();
        this.resetForm();
      }
    },
    "form.appName"() {
      if (this.searchDataFlag) return;
      if (this.form.sourceType === "1") {
        this.findKpiKeys();
      }
    },
    "form.group"() {
      if (this.searchDataFlag) return;
      this.waitAppList(this.form.siteCode, this.form.group);
    }
  },
  mounted() {
    this.e_init();
  }
};
</script>
<style scoped>
.addStratagy__content .t-table {
  display: inline-table;
  width: 850px;
  border-collapse: collapse;
  vertical-align: middle;
}
.addStratagy__content .t-table.t-tableMin {
  width: 500px;
}
.addStratagy__content .t-border {
  height: 30px;
  width: 90px;
  padding-left: 8px;
  text-align: left;
  border: 1px solid #ddd;
}
.addStratagy__content .t-border-none {
  border: none;
}
.addStratagy__content .t-nopd {
  padding-left: 0px;
  text-align: center;
}
.addStratagy__content .alarmMonent.t-border {
  width: 153px;
}
.addStratagy__content .alarmMonent.t-border div {
  display: inline-block;
}
.addStratagy__content .alarmMonent .to {
  text-align: center;
  display: inline-block;
}
.addStratagy__content .addStratagy__checkbox {
  display: block;
  width: 200px;
  border: 1px solid #ddd;
  height: 120px;
  overflow-y: scroll;
  padding: 2px 4px;
}
.addStratagy__content .t-border.t-map {
  width: 200px;
  text-align: center;
}
.addStratagy__form {
  width: 800px;
}
.addStratagy__content .addStratagy__w700 {
  width: 700px;
}
.addStratagy__content .addStratagy__w500 {
  width: 500px;
}
.addStratagy__content .addStratagy__checkItem {
  margin-left: 0px;
  margin-right: 10px;
}
.addStratagy__content .addStratagy__checkbox--large {
  width: 500px;
  display: block;
  border: 1px solid #ddd;
  height: 120px;
  overflow-y: scroll;
  padding: 2px 4px;
}
.addStratagy__content .addStratagy__center {
  margin-left: 100px;
}
.addStratagy__content .addStratagy__w200 {
  width: 200px;
}
</style>
